import _ from 'lodash';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {parseApplicationUidFromTopicType} from '../../../../../../helpers/models/topicHelpers';
import {TopicModel} from '../../../../../../models/api/topicModel';
import {AppState} from '../../../../../../store/appState';
import {getFlatApplications} from '../../../../../../store/data/applications/applicationsSelectors';
import {getIntegrationsByType} from '../../../../../../store/data/dataSelectors';
import {ConversationHeaderReferencePreviewerPill} from './conversationHeaderReferencePreviewerPill';

/*
 * Props.
 */

interface ConversationHeaderReferencePreviewerPillContainerProps {
  topic: TopicModel;
}

/*
 * Selectors.
 */

function getTopic(_state: AppState, props: ConversationHeaderReferencePreviewerPillContainerProps) {
  return props.topic;
}

function makeGetApplication() {
  return createSelector([getTopic, getFlatApplications], (topic, applications) => {
    const applicationUid = parseApplicationUidFromTopicType(topic);
    return _(applications).find((app) => app.uid === applicationUid);
  });
}

function makeGetTopicType() {
  return createSelector([getTopic, getIntegrationsByType], (topic, integrations) => {
    const integration = integrations[topic.type];
    return integration && integration.topicType;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationHeaderReferencePreviewerPillContainerProps>()(() => ({
  application: makeGetApplication(),
  topicType: makeGetTopicType(),
}));

export const ConversationHeaderReferencePreviewerPillContainer = connect(mapStateToProps)(
  ConversationHeaderReferencePreviewerPill,
);
